import ReactDom from "react-dom";

const DomPortal = (props) => {
  const { children, slideInDom, ...rest } = props;

  if (slideInDom) {
    return ReactDom.createPortal(children, slideInDom);
  }

  return children;
};

export default DomPortal;
